module.exports = __webpack_public_path__ + "img/CyberSecurity.549e5447.png";